import styled from 'styled-components';
import { Icons } from '../../atoms';
import { makeStyles } from '@material-ui/core';

const StyledContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.secondary};
  display: flex;
  justify-content: center;
`;

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    maxWidth: 2560,
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 16,
    padding: '8px 20rem 8px 20rem',
    [theme.breakpoints.down(2560)]: {
      maxWidth: 2560,
    },
    [theme.breakpoints.down(1440)]: {
      maxWidth: 1440,
    },
  },
}));

const TopMedsos = () => {
  const classes = useStyles();
  return (
    <StyledContainer>
      <div className={classes.container}>
        <Icons.IconInstagram />
        <Icons.IconYoutube />
        <Icons.IconFacebook />
        <Icons.IconTwitter />
      </div>
    </StyledContainer>
  );
};

export default TopMedsos;
